import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MailItem, MailItemList } from '@shared/models/mail-item';
import { EMPTY, Observable } from 'rxjs';
import { CommonService } from './common.service';
import { map } from 'rxjs/operators';

import inboxListMocks from '@mocks/mailList2.json';
import inboxListDeletedMocks from '@mocks/mailListDeleted.json';
import inboxListSentdMocks from '@mocks/mailListSent.json';

import { InboxItem, InboxItemList } from '@shared/models/inbox-item';
import { MailItemCheckbox } from '@shared/models/mail-item-checkbox';
import { AkMessage } from '@shared/models/ak-message';
import emptyResponse from '@mocks/emptyResponse.json';

@Injectable({
    providedIn: 'root'
})
export class InboxService {
    private emptyResponse: object;
    private inboxList: InboxItemList;
    private inboxListDeleted: InboxItemList;
    private inboxListSent: InboxItemList;

    constructor(
        private commonService: CommonService,
        private http: HttpClient
    ) {
        this.emptyResponse = emptyResponse;
        this.inboxList = inboxListMocks;
        this.inboxListDeleted = inboxListDeletedMocks;
        this.inboxListSent = inboxListSentdMocks;
    }

    getInboxList(type: string = 'inbox', wsPage?: number): Observable<MailItemList> {

        if (this.commonService.useMocks) {

            let list = this.inboxList;
            switch (type) {
                case 'sent':
                    list = this.inboxListSent;
                    break;
                case 'deleted':
                    list = this.inboxListDeleted;
                    break;
            }

            return new Observable(observer => observer.next(list)).pipe(map(this.mapInboxList));
        }

        let url = this.commonService.getServiceUrl('inbox');
        url = url + '?type=' + type;
        if (wsPage != undefined) {
            url = url + '&page=' + wsPage;
        }

        return this.http.get<InboxItemList>(url).pipe(map(this.mapInboxList));
    }

    getMessagesInThread(threadId: number): Observable<MailItem[]> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.inboxListDeleted.list)).pipe(map(this.mapInboxItem));
        }

        return this.http.get<InboxItem[]>(this.commonService.getServiceUrl(`inbox/${threadId}/messages`)).pipe(map(this.mapInboxItem));
    }

    postUpdateAkInbox(mailItem: MailItem): Observable<any> {
        if (this.commonService.useMocks) {
            return EMPTY;
        }
        return this.http.post(this.commonService.getServiceUrl(`inbox/${mailItem.checkbox.id}`), {
            unread: false
        });
    }

    private mapInboxItem(mailItems: InboxItem[]): MailItem[] {

        let list: MailItem[] = [];
        mailItems.forEach((item: InboxItem) => {
            list.push({
                variant: item.unread ? "unread" : "read",
                name: item.mailFrom,
                title: item.mailSubj,
                attachment: (item.upPid && item.upItemId) ? true : false,
                attachmentId: (item.upPid && item.upItemId) ? item.upItemId : '',
                date: item.mailSend,
                content: item.mailBody,
                unread: item.unread,
                threadId: item.threadId,
                fromAsp: item.directionLabel == 'Allianz -> AK Klient',
                policyNumber: item.policyNumber,
                claimNumber: item.claimNumber,
                dms2docId: item.dms2docId,
                dms2docBrandId: item.dms2docBrandId,
                dms2docCatId: item.dms2docCatId,
                dms2DocboxId: item.dms2DocboxId,
                dms2Actnumber: item.dms2Actnumber,
                dms2Secflag: item.dms2Secflag,
                checkbox: {
                    id: item.id,
                    checked: false,
                    value: item.id
                } as MailItemCheckbox

            } as MailItem);
        });

        return list;
    }

    private mapInboxList(inboxItems: InboxItemList | undefined): MailItemList {
        let mailItems = new MailItemList();
        mailItems.list = new Array<MailItem>();

        if (inboxItems === undefined) {
            return mailItems;
        }

        inboxItems.list.forEach(item => {
            mailItems.list.push({
                variant: item.unread ? "unread" : "read",
                name: item.mailFrom,
                title: item.mailSubj,
                attachment: (item.upPid && item.upItemId) ? true : false,
                attachmentId: (item.upPid && item.upItemId) ? item.upItemId : '',
                date: item.mailSend,
                content: item.mailBody,
                unread: item.unread,
                threadId: item.threadId,
                fromAsp: item.directionLabel == 'Allianz -> AK Klient',
                policyNumber: item.policyNumber,
                claimNumber: item.claimNumber,
                dms2docId: item.dms2docId,
                dms2docBrandId: item.dms2docBrandId,
                dms2docCatId: item.dms2docCatId,
                dms2DocboxId: item.dms2DocboxId,
                dms2Actnumber: item.dms2Actnumber,
                dms2Secflag: item.dms2Secflag,
                checkbox: {
                    id: item.id,
                    checked: false,
                    value: item.id
                } as MailItemCheckbox

            } as MailItem);
        });

        mailItems.pagination = inboxItems.pagination;
        mailItems.unreadMessagesCount = inboxItems.unreadMessagesCount;
        return mailItems;
    }

    public postCreateAkMessage(akMessage: AkMessage): Observable<AkMessage | object> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.emptyResponse));
        }

        return this.http.post<AkMessage>(this.commonService.getServiceUrl('inbox'), akMessage);
    }

    postRemoveMessage(messageId: number): Observable<any> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.emptyResponse));
        }

        return this.http.post(this.commonService.getServiceUrl(`inbox/${messageId}/remove`), {
            'suppressUnreads': true,
            'suppressOtherMsgs': true
        });
    }
}
